// useSubscribedNode.js

import { useEffect, useState } from 'react';

import { subscribeToNode } from 'services/nodes/NodeReadService';

/**
 * Live Firestore subscription for a single node document.
 *
 * @param {string|null|undefined} nodeKey
 * @param {{ enabled?: boolean }} [options]
 * @returns {object|null}
 */
export default function useSubscribedNode(nodeKey, { enabled = true } = {}) {
  const [node, setNode] = useState(null);
  const key = typeof nodeKey === 'string' ? nodeKey.trim() : '';

  useEffect(() => {
    if (!enabled || !key) {
      setNode(null);
      return undefined;
    }

    const unsubscribe = subscribeToNode(key, (next) => {
      setNode(next || null);
    });

    return () => {
      unsubscribe?.();
    };
  }, [enabled, key]);

  return node;
}
